module.exports = __webpack_public_path__ + "img/iStock-1139819021-Frau-mit-Fahrrad-am-Wasser-2121x1414-1-1024x683-2.773701b7.jpg";